<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">All Active Reviews</h4>
            <p v-if="hasReviews" class="category">Here you will find all of your reviews.</p>
            <p v-if="!hasReviews" class="category">You currently do not have any reviews.</p>
          </div>
          <div class="card-content">
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>

    <div class="row">
      <div class="col-lg-3 col-sm-6" v-for="review in reviews">
        <review-card :review-id="review.id" :review="review" @remove="fetchReviews">
          <div slot="video-link-thumb">
            <a :href="createVidUrl(review)" target="_blank"><img :src="createThumbUrl(review)" :alt="review.title" style="display: block; width: 150px; margin-left: auto; margin-right: auto;" /></a>
          </div>
          <div slot="title">
            {{review.title}}
          </div>
        </review-card>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  import ReviewCard from 'src/components/UIComponents/Cards/ReviewCard.vue'
  import store from '@/store'

  export default {
    components: {
      ReviewCard
    },
    data () {
      return {
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ''
          },
          responseType: 'text'
        },
        reviews: []
      }
    },
    computed: {
      hasReviews: function () {
        return this.reviews.length > 0
      }
    },
    methods: {
      createThumbUrl (review) {
        let url = review.thumbnail_url
        return url
      },
      createVidUrl (review) {
        let url = review.video_url
        return url
      },
      fetchReviews () {
        this.$cognitoAuth.isAuthenticatedWithAttributes((err, response) => {
          if (err) {
            console.log(err)
            this.$router.replace('/login')
          } else if (!response) {
            this.user = false
            this.loggedIn = false
            this.$router.replace('/login')
          } else {
            console.log('getIdToken')
            this.$cognitoAuth.getIdToken((err, response) => {
              if (err) {
                console.log('error:')
                console.log(err)
              } else {
                console.log('got new id token')
                console.log(response)
                this.axios_config.headers.Authorization = 'Bearer ' + response
                console.log(this.axios_config)

                let businessId = store.getUser().business_id
                let endpoint = 'https://ppeslocator.com' + businessId + '/reviews'
                console.log('calling ' + endpoint)
                axios.get(endpoint, this.axios_config)
                .then((response) => {
                  console.log(response)
                  this.reviews = response.data
                })
                .catch((error) => {
                  console.log('error fetching reviews')
                  console.log(error)
                  this.$router.replace('/login?logout=true')
                })
              }
            })
          }
        })
      }
    },
    created: function () {
      this.fetchReviews()
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Reviews.vue